<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Projects" searchable="true"></list-nav-header>

            <list-action-bar>
                <a :href="createUrl"><i class="fa fa-plus" aria-hidden="true"></i> Create New Project</a>
            </list-action-bar>

            <list-nav-scroll>

                <table class="responsive-table fix-head">
                    <thead>
                    <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Aim</th>
                        <th scope="col">Practical Completion Date</th>
                        <th scope="col">Package Count</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td scope="row" data-label="Title">{{ item.title }}</td>
                        <td data-label="Aim">{{ item.aim }}</td>
                        <td data-label="Practical Completion Date">{{ item.practical_completion_date }}</td>
                        <td data-label="Package Count">{{ item.package_count }}</td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Projects
                                </span>
                            </infinite-loading>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props: ['createUrl'],
        data() {
            return {
                name: 'projectslist',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.projects.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
</style>
